module.exports = __webpack_public_path__ + "img/insta-icon-white.9039041.svg";